export const TECHNICAL_REASONS = [1, 4]
export const UNEXPECTED_EVENT = [2, 5]
export const OTHER_REASONS = [3, 6]
export const PROFESSIONAL_DECISION = 7


// WEBPACK FOOTER //
// ./src/constants/db/cancelationReasons.js